import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ChatbotWidget from "./components/ChatbotWidget";
import PromoStrip from "./components/PromoStrip";

import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import BookingPage from "./pages/BookingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import ClientDashboard from "./pages/ClientDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AIQuotePage from "./pages/AIQuotePage";
import ContactPage from "./pages/ContactPage";
import MembershipPage from "./pages/MembershipPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#0B5D3B]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }) {
  return (
    <>
      <PromoStrip />
      <Navbar />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <ChatbotWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Shell><HomePage /></Shell>} />
            <Route path="/services" element={<Shell><ServicesPage /></Shell>} />
            <Route path="/booking" element={<Shell><BookingPage /></Shell>} />
            <Route path="/ai-quote" element={<Shell><AIQuotePage /></Shell>} />
            <Route path="/membership" element={<Shell><MembershipPage /></Shell>} />
            <Route path="/contact" element={<Shell><ContactPage /></Shell>} />
            <Route path="/login" element={<Shell><LoginPage /></Shell>} />
            <Route path="/register" element={<Shell><RegisterPage /></Shell>} />
            <Route path="/forgot-password" element={<Shell><ForgotPasswordPage /></Shell>} />
            <Route path="/reset-password" element={<Shell><ResetPasswordPage /></Shell>} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/dashboard" element={<Protected><Shell><ClientDashboard /></Shell></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><Shell><AdminDashboard /></Shell></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
